import { z } from "zod";

export const salesUserSchema = (isEdit) =>
  z
    .object({
      name: z.string().trim().min(1, "Name is required"),

      email: z.string().trim().min(1, "Email is required").email("Invalid email format"),

      phone: z.string().trim().min(1, "Phone number is required"),

      role: z.string().trim().min(1, "Role is required"),

      password: isEdit
        ? z.string().trim().optional()
        : z.string().trim().min(1, "Password is required"),
    })
    .passthrough()
    .superRefine((data, ctx) => {
      if (data.password) {
        const pass = data.password;

        if (pass.length < 8) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: "Password must be at least 8 characters long",
            path: ["password"],
          });
        }

        if (!/[A-Z]/.test(pass)) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: "At least one uppercase letter required",
            path: ["password"],
          });
        }

        if (!/[a-z]/.test(pass)) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: "At least one lowercase letter required",
            path: ["password"],
          });
        }

        if (!/[0-9]/.test(pass)) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: "At least one number required",
            path: ["password"],
          });
        }

        if (!/[^A-Za-z0-9]/.test(pass)) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: "At least one special character required",
            path: ["password"],
          });
        }

        if (/\s/.test(pass)) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: "Password must not contain spaces",
            path: ["password"],
          });
        }
      }

      if (data.phone) {
        const mob = data.phone;

        if (mob.length < 8) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: "Mobile number must be at least 8 digits",
            path: ["phone"],
          });
        }

        if (mob.length > 12) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: "Mobile number must be under 12 digits",
            path: ["phone"],
          });
        }

        if (!/^\d+$/.test(mob)) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: "Mobile number must only contain digits",
            path: ["phone"],
          });
        }
      }
    });

export const parseSalesUserErrors = (data, isEdit) => {
  const result = salesUserSchema(isEdit).safeParse(data);

  if (result.success) return {};

  const errors = {};

  for (const issue of result.error.issues) {
    const key = issue.path.join(".");
    if (!errors[key]) {
      errors[key] = issue.message;
    }
  }

  return errors;
};
